<template>
    <div class="form">

        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('managers.headline.user_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="username"
                        v-model="fields.username"
                        :placeholder="manager && manager.username ? manager.username : trans('managers.label.username_will_be_generated')"
                        disabled="disabled"
                    >
                        {{ trans('managers.label.username') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <label class="label" for="gender">{{ trans('managers.label.salutation') }}</label>
                    <select
                        name="gender"
                        v-model="fields.gender"
                        :class="['form-select', {'form-select--error': errors('gender')}]"
                    >
                        <option disabled>{{ trans('managers.label.select') }}</option>
                        <option value="">{{ trans('managers.label.not_specified') }}</option>
                        <option :value="gender" v-for="gender in genders" :key="gender">{{ trans('managers.label.' + gender) }}</option>
                    </select>
                    <span class="invalid-feedback" v-if="errors('gender')">
                        <strong>{{ errors('gender') }}</strong>
                    </span>
                </div>

                <div class="form-row__col">
                    <form-input
                        name="title"
                        v-model="fields.title"
                    >
                        {{ trans('managers.label.title') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <form-input
                        name="firstname"
                        :required="true"
                        v-model="fields.firstname"
                    >
                        {{ trans('managers.label.firstname') }}
                    </form-input>
                </div>
                <div class="form-row__col">
                    <form-input
                        name="lastname"
                        :required="true"
                        v-model="fields.lastname"
                    >
                        {{ trans('managers.label.lastname') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row" v-if="nameChanged && canChangeUsername">
                <div class="form-row__col form-row__col--one-half">
                    <checkbox
                        name="change_username"
                        value="true"
                    >
                        {{ trans('managers.label.change_username') }}
                    </checkbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="email"
                        :required="true"
                        v-model="fields.email"
                    >
                        {{ trans('managers.label.email') }}
                    </form-input>
                </div>
            </div>
        </section>

        <section class="form-section">
            <label class="form-section-heading">
                {{ trans('managers.label.role') }}
            </label>

            <div>
                <checkbox-wrapper name="roles[]">
                    <checkbox-card
                        :disabled="canNotChangeRole"
                        :card="card"
                        icon="/images/icon-user.svg"
                        name="roles[]"
                        v-for="(card, index) in checkboxes"
                        :key="index"
                    ></checkbox-card>
                </checkbox-wrapper>
            </div>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <a v-if="canChangePassword"
                    :href="route('main.password.edit')"
                    class="btn btn--big btn--tertiary">
                        {{ trans('managers.label.change_password') }}
                </a>
            </div>
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">{{ trans('buttons.submit') }}</button>
            </div>
        </div>


    </div>
</template>

<script>

export default {
    props: ['manager', 'canChangePassword', 'canNotChangeRole', 'canChangeUsername', 'validationErrors'],
    data() {
        return {
            fields: {
                roles: this.manager ? this.manager.roles_id : [],
                gender: this.old ('gender', this.manager.gender),
                title: this.old('title', this.manager.title),
                firstname: this.old('firstname', this.manager.firstname),
                lastname: this.old('lastname', this.manager.lastname),
                username: this.old('username', this.manager.username),
                email: this.old('email', this.manager.email),
            },

            genders: [
                'male',
                'female',
                'other'
            ],
        };
    },

    computed: {
        nameChanged() {
            if (this.manager && this.manager.username) {
                var username = this.fields.username.split('.');

                // Find firstname in username
                var firstnameEqual = username.find((value) => {
                    return value == this.fields.firstname.toLowerCase();
                });

                // Find lastname in username
                var lastnameEqual = username.find((value) => {
                    return value == this.fields.lastname.toLowerCase();
                });

                // Username can be updated when the fields are updated by manager or if firstname and lastname dont match the current username
                if (this.manager.firstname != this.fields.firstname || this.manager.lastname != this.fields.lastname || !firstnameEqual || !lastnameEqual) {
                    return true;
                }
            }
            return false;
        },
        checkboxes() {
            return [
                {
                    'value': '1',
                    'title': this.trans('managers.role.admin'),
                    'description': this.descriptionText(this.trans('managers.role_description.admin')),
                    'status': this.fields.roles.includes(1),
                },
                {
                    'value': '2',
                    'title': this.trans('managers.role.editor'),
                    'description': this.descriptionText(this.trans('managers.role_description.editor')),
                    'status': this.fields.roles.includes(2),
                },
                {
                    'value': '3',
                    'title': this.trans('managers.role.accounting'),
                    'description': this.descriptionText(this.trans('managers.role_description.accounting')),
                    'status': this.fields.roles.includes(3),
                },
                {
                    'value': '4',
                    'title': this.trans('managers.role.support'),
                    'description': this.descriptionText(this.trans('managers.role_description.support')),
                    'status': this.fields.roles.includes(4),
                },
            ];
        }
    },
    methods: {
        descriptionText(descriptionsArray) {
            var descriptionHtml = "<ul>";

            descriptionsArray.forEach(descriptionLine => {
                descriptionHtml += "<li>" + descriptionLine + "</li>";
            });

            return (descriptionHtml + "</ul>");
        }
    }
};
</script>
